// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_Boq","cls2":"PaperClaiming-cls2_yqR PaperClaiming-cls1_Boq"};